import About from "./componebts/About/About";
import Collection from "./componebts/collections/Collection";
import Contact from "./componebts/Contact/Contact";
import Footer from "./componebts/Footer/Footer";
import Hero from "./componebts/Hero/Hero";
import Nav from "./componebts/Nav/Nav";
import Testimonials from "./componebts/Testimonials/Testimonials";

function App() {
  return (
    <>
    <Nav/>
    <Hero/>
    <About/>
    <Collection/>
    <Contact/>
    <Testimonials/>
    <Footer/>
    </>
  );
}

export default App;
